interface ProductUnitNames {
  [unit: string]: SingularPluralUnitName;
}

interface SingularPluralUnitName {
  singular: string;
  plural: string;
}

export function GetUnitText(text: string, singular: boolean): string {
  const units: ProductUnitNames = {
    [`T n`]: { singular: 'tonelada', plural: 'toneladas' },
    [`toneladas`]: { singular: 'tonelada', plural: 'toneladas' },
    [`millares`]: { singular: 'millar', plural: 'millares' },
    [`bolsas`]: { singular: 'bolsa', plural: 'bolsas' },
    [`unidades`]: { singular: 'unidad', plural: 'unidades' },
    [`cajas`]: { singular: 'caja', plural: 'cajas' },
    [`paquetes`]: { singular: 'paquete', plural: 'paquetes' },
  };

  if (!units[text]) {
    return text;
  }

  if (singular) {
    return units[text].singular;
  }

  return units[text].plural;
}
